module.exports = __webpack_public_path__ + "static/media/prof_pic.3c2330f0.jpg";